<template>
   <router-view />
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
	name: "App",
	data() {
	return {
		  locale: zhCN
		};
	}, 
	created(){ 
	},
	mounted() {
  	
	  	var os = function() {
	    var ua = navigator.userAgent,
	        isWindowsPhone = /(?:Windows Phone)/.test(ua),
	        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
	        isAndroid = /(?:Android)/.test(ua),
	        isFireFox = /(?:Firefox)/.test(ua),
	        isChrome = /(?:Chrome|CriOS)/.test(ua),
	        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
	        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
	        isPc = !isPhone && !isAndroid && !isSymbian;
			    return {
			        isTablet: isTablet,
			        isPhone: isPhone,
			        isAndroid: isAndroid,
			        isPc: isPc
			    };
			}();

		if(os.isAndroid || os.isPhone) {  
		   	var oMeta = document.createElement('meta');
	        oMeta.content = 'width=device-width, initial-scale=0.5, maximum-scale=0.5,minimum-scale=0.5, user-scalable=no';
	        oMeta.name = 'viewport';
	        document.getElementsByTagName('head')[0].appendChild(oMeta)
	        
	        var style = document.createElement('style'); /// 
			style.type = 'text/css'; 
			style.innerHTML = `
				.team-top li{ 
    				padding: 0 5px!important;
    				margin: 0 2px!important;
    			}
    			.team-major li{ 
    				padding: 0 6px!important;
    			}
    			.team-list li span{ 
    				width: 82px!important;
    			}
    			.build-button button {
    				padding: 8px 13px!important;
    				margin: 7px 5px 0!important;
    			} 
    			.Setup-button button{ 
    				margin: 0 12px!important;
    			} 
    			.delete-team-btn-total { 
    				right: 35px!important; 
    			}
    			.user-head-img{
    				margin: 0 11px 0 16px!important;
    			}
    			.build-detail-btn{
    				right:90px!important;
    			}
    		`; 
			document.getElementsByTagName('head')[0].appendChild(style);  

		} else if(os.isTablet) {
		    var oMeta = document.createElement('meta');
	        oMeta.content = 'width=device-width, initial-scale=1, maximum-scale=1,minimum-scale=1, user-scalable=no';
	        oMeta.name = 'viewport';
	        document.getElementsByTagName('head')[0].appendChild(oMeta); 

	        var style = document.createElement('style'); 
			style.type = 'text/css'; 
			style.innerHTML = `
				.rescue-center-data-left{ 
    				width: 17%!important; 
    				text-align:center; 
    			} 
    		`; 
			document.getElementsByTagName('head')[0].appendChild(style);  

		} else if(os.isPc) { //

		}
	}
};





</script>
<style lang="less">
th.column-center,
td.column-center {
  text-align: center !important;
}
</style>


